<template>
  <div class="LiveList">
    <div class="tableTitle">
      <i class="icon icon-shu"></i>我的直播
      <div  v-show="true" @click="showAdd(0)" class="LiveBtn">
        <img src="@/assets/images/liveLogo.png" alt="" class="liveLogo">
        发起直播
      </div>
    </div>
    <table class="table el-col-23" border="1">
      <thead class="thead">
      <td>标题</td>
      <td>开课时间</td>
      <td>直播时长(分钟)</td>
      <td>直播状态</td>
      <td width="200">选项</td>
      </thead>
      <tr v-for="(item,index) in storeroom.list">
        <td>{{item.Title}}</td>
        <td>{{item.OpeningHours}}</td>
        <td>{{item.Duration}}分钟</td>
        <td>{{item.TypeText}}</td>
        <td>
          <span @click="showAdd(item,item.ID)" class="editBtn">编辑</span>
          <span @click="del(item.ID)" class="delBtn">删除</span>
        </td>
      </tr>
    </table>
    <!--        分页-->
    <div v-if="storeroom.total>=6" class="block el-col-24">
      <el-pagination
        @current-change="storeroomChange"
        :current-page.sync="storeroom.page"
        :page-size="storeroom.limit"
        layout="prev, pager, next, jumper"
        :total="storeroom.total">
      </el-pagination>
    </div>
    <!--    发起直播-->
    <el-dialog
      class="tk"
      title=""
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div class="tkLi">
        <span>标题：</span>
        <el-input v-model="form.Title" placeholder="请输入标题"></el-input>
      </div>
      <div class="tkLi">
        <span>开课时间 ：</span>
        <el-date-picker
          style="width: 100%;"
          v-model="form.OpeningHours"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="tkLi">
        <span>直播时长 ：</span>
        <el-input
          type="number"
          style="width: 70%;padding-right: 1%"
          v-model="form.Duration"
          placeholder="请输入时长"></el-input>
        分钟
      </div>
      <div class="tkLi">
        <span>直播范围 ：</span>
        <el-select style="width: 100%;" v-model="form.GradeId" multiple placeholder="请选择">
          <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.GTypeSrc+' '+item.Grade+ ' '+item.Class"
            :value="item.ID">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Header from '@/components/Header'

  export default {
    name: "LiveList",
    data() {
      return {
        time: '',
        form: {
          Title: '',
          OpeningHours: new Date(),
          Duration: '50',
          GradeId: [],
        },
        storeroom: {    //列表分页
          list: [],
          page: 1,
          limit: 10,
          total: 30,
        },
        radioArr: [],   //匹配列表
        ppkc: false,  //匹配课程弹框
        radio: 1, //匹配课程的id
        centerDialogVisible: false,
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value1: [],
        id: 0,
      }
    },
    watch: {
      // 'form.OpeningHours'(val, oldval) {
      //   console.log(val);
      //   this.form.OpeningHours = val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate() + ' ' + val.getHours() + ':' + val.getMinutes() + ':' + val.getSeconds();
      // }
    },
    mounted() {
      this.getList();
      this.getClass();
    },
    methods: {
      getClass() {
        let that = this;
        this.axios.post(window.url + 'AdminClass', {}).then(res => {
          let data = res.data;
          that.returnCode(data.result, data.message);
          that.options = data.data;
        }).catch(error => {
          // that.$message.error('您的网络开小差了！')
        });
      },
      getList() {
        let that = this;
        this.axios.post(window.url + 'GetLive', {
          currentPage: that.storeroom.page,
          pageSize: that.storeroom.limit,
        }).then(res => {
          let data = res.data;
          that.returnCode(data.result, data.message);
          if (data.data.Content.length == 0) {
            that.storeroom = {    //列表分页
              list: [],
              page: 1,
              limit: 10,
              total: 0,
            };
          } else {
            data.data.Content.forEach(function (item, index) {
              if (item.Type == 0) {
                item.TypeText = '到时未开播过期';
              } else if (item.Type == 1) {
                item.TypeText = '未开播';
              } else if (item.Type == 2) {
                item.TypeText = '正在直播';
              } else if (item.Type == 3) {
                item.TypeText = '结束直播';
              }
            });
            that.storeroom.list = data.data.Content;
            that.storeroom.total = data.data.totalSize;
          }
        }).catch(error => {
          // that.$message.error('您的网络开小差了！')
        });
      },
      // 分页start
      storeroomChange(e) {
        let that = this;
        that.storeroom.page = e;
        that.getList();
      },
      // 分页end

      showAdd(item, id) {
        let that = this;
        //console.log('当前编辑的项',item,'当前的表单',that.form);
        that.id = id;
        that.centerDialogVisible = true;
        if(item!==0){
          that.form.Title=item.Title;
          that.form.OpeningHours = new Date(item.OpeningHours);
          that.form.Duration=item.Duration;
          that.form.ID= item.ID;
          that.form.GradeId=[];
          for(let tm of item.PrivilegeList){
            that.form.GradeId.push(tm.GradeId)
          }
        }
        else {
          that.id=0;
          this.form= {
            Title: '',
            OpeningHours: new Date(),
            Duration: '50',
            GradeId: [],
          }
        }
      },
      formatTime(tip){
        let val=new Date(tip);
        return val.getFullYear() + '-' + (val.getMonth() + 1) + '-' + val.getDate() + ' ' + val.getHours() + ':' + val.getMinutes() + ':' + val.getSeconds();
      },
      add() {
        let that = this;
        if(that.form.Title==="" || that.form.GradeId.length<=0){
          that.$message.error("数据必须填写");
          return;
        }
        let tmp={
          ID: that.id,
          Title: that.form.Title,
          OpeningHours: that.formatTime(that.form.OpeningHours.getTime()),
          Duration: that.form.Duration,
          GradeId: that.form.GradeId,
        };
       // console.log("当前的数据:",tmp);
        // console.log("当前直播数据",tmp);
        // return;
        // return;
        this.axios.post(window.url + 'LiveHandle', tmp).then(res => {
          let data = res.data;
          that.returnCode(data.result, data.message);
          that.$message.success(data.message);
          that.page = 1;
          that.getList();
          that.centerDialogVisible = false;
          this.form= {
            Title: '',
            OpeningHours: new Date(),
            Duration: '50',
            GradeId: [],
          }
        }).catch(error => {
          // that.$message.error('您的网络开小差了！')
        });
      },
      del(id) {
        let that = this;
        this.$confirm('确认删除该直播预约, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post(window.url + 'DeleteLive', {
            ID: id
          }).then(res => {
            let data = res.data;
            that.returnCode(data.result, data.message);
            that.$message.success(data.message);
            that.page = 1;
            that.getList();
          }).catch(error => {
            // that.$message.error('您的网络开小差了！')
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },
      // 返回值调用
      returnCode(code, msg) {
        var that = this;
        if (code != 200) {
          if (code == 201) {
            this.$router.push({name: 'Login'});
          }
          that.$message.error(msg);
          return;
        }
      },
    },
    components: {
      Header
    }
  }
</script>

<style lang="less" scoped>
  .LiveList {
    .tableTitle {
      height: 70px;
      line-height: 70px;
      font-size: 22px;
      text-align: left;

      .icon-shu {
        font-size: 24px;
        background: #59bf85;
        border-radius: 2px;
        width: 5px;
        height: 18px;
        margin: 0px 10px;
        display: inline-block;
      }

      .shaohou {
        height: 36px;
        margin-left: 30px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }

      .LiveBtn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        float: right;
        color: #ffffff;
        text-align: center;
        font-size: 14px;
        margin-top: 20px;
        background-color: #E3675C;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        cursor: pointer;

        .liveLogo {
          width: 16px;
        }
      }
    }

    .table {
      border: 1px solid #E3E5E7;
      margin: 0 auto;
      width: 100%;

      .pipeiImg {
        display: block;
        width: 100px;
        height: 34px;
        margin: 10px auto;
      }

      .thead {
        background-color: #F6F6F6;

        td {
          text-align: center;
        }
      }

      tr {
        cursor: pointer;

        td:nth-child(1) {
          text-align: left;
          text-indent: 2em;
        }
      }

      td {
        height: 44px;
        line-height: 44px;

        .editBtn {
          color: #1E87F0;
          padding: 0 10px;
          cursor: pointer;
        }

        .delBtn {
          color: #E66262;
          padding: 0 10px;
          cursor: pointer;
        }
      }
    }

    .block {
      margin-top: 20px;
    }

    .addClass {
      background-color: #149BD7FF;
      float: left;
      margin: 30px;
      padding: 6px 30px;
      color: #ffffff;
      cursor: pointer;
      font-size: 16px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
    }

    .tk_top {
      height: 40px;
      line-height: 40px;
      text-indent: 2em;
      background-color: #EAEDF2;

      span {
        width: 40%;
        text-align: left;
        float: right;
      }
    }

    .radioBox {
      border-bottom: 1px solid #dedede;
      padding: 0 5%;
      line-height: 40px;
      height: 40px;
      overflow: hidden;

      .el-radio {
        width: 60%;
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .el-time {
        width: 30%;
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .tk {
      .tkLi {
        width: 50%;
        padding: 15px 0 15px 15%;
        margin: 0 auto;
        position: relative;

        span {
          line-height: 40px;
          position: absolute;
          left: 1px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LiveList.vue